import L from 'leaflet';
import yellowCircle from '../assets/yellowCircle.png';
import redCircle from '../assets/redCircle.png';
import purpleCircle from '../assets/purpleCircle.png';
delete L.Icon.Default.prototype._getIconUrl;

let yellowCircleIcon = L.icon({
  iconUrl: yellowCircle,
  iconSize: [20, 20],
  // shadowSize: [50, 64],
  iconAnchor: [10, 10],
  // shadowAnchor: [4, 62],
  // popupAnchor: [-3, -76]
});
let redCircleIcon = L.icon({
  iconUrl: redCircle,
  iconSize: [20, 20],
  iconAnchor: [10, 10],
});
let purpleCircleIcon = L.icon({
  iconUrl: purpleCircle,
  iconSize: [20, 20],
  iconAnchor: [10, 10],
});

export { yellowCircleIcon, redCircleIcon, purpleCircleIcon };
